module.exports = __webpack_public_path__ + "static/media/d.3d17f058.jpg";